import { render, staticRenderFns } from "./NovaCargaPosRow.vue?vue&type=template&id=797625c3&scoped=true&"
import script from "./NovaCargaPosRow.vue?vue&type=script&lang=js&"
export * from "./NovaCargaPosRow.vue?vue&type=script&lang=js&"
import style0 from "./NovaCargaPosRow.vue?vue&type=style&index=0&id=797625c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797625c3",
  null
  
)

export default component.exports